module.exports = __webpack_public_path__ + "img/toplogo.42c3859d.png";